import React from 'react';
import { FiInfo } from 'react-icons/fi';
import PropTypes from 'prop-types';
import { InfoCardContainer } from './style';

export default function InfoCard({ children, marginBottom, marginTop }) {
  return (
    <InfoCardContainer $marginBottom={marginBottom} $marginTop={marginTop}>
      <FiInfo />
      {children}
    </InfoCardContainer>
  );
}

InfoCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  marginBottom: PropTypes.number,
  marginTop: PropTypes.number
};

InfoCard.defaultProps = {
  marginBottom: 16,
  marginTop: 0
};
